import { defineStore } from 'pinia';

export const baseLoaderStore = defineStore('baseLoaderStore',{
    state: () => ({
        loaderState: false,
    }),
    actions: {
        showBaseLoader() {
            this.loaderState = true;
        },
        hideBaseLoader() {
            this.loaderState = false;
        }
    }
})